import { Component } from '@angular/core';
import { CostCenter } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { CostCenterService } from '../../services/cost-centre.service';

@Component({
  selector: 'app-cost-centre-dropdown',
  template: '',
  standalone: true,
})
export class CostCenterDropdownComponent extends GenericBaseModelDropDown<CostCenter> {

  constructor(
    private service: CostCenterService) {
    super(service, "CostCenter");
  }
}